import React, { ReactNode } from 'react'
import { useTranslation } from 'language/translator'

import { ComparativeDisplayType } from 'types/GlobalKpiOption'

import { translateComparativeDisplayType } from 'utils/enumTranslator'

import Grid from 'components_new/atoms/Grid'
import Switch from 'components_new/atoms/Switch'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import SettingsToggleOption from 'components_new/molecules/SettingsToggleOption'

import { getOptions } from './utils'

interface ComparativeDisplayTypeSectionProps {
  // a comparison is only displayed against a period to compare with
  hasComparativePeriod: boolean
  onChange: (displayType: ComparativeDisplayType) => void
  options: ComparativeDisplayType[]
  selected: ComparativeDisplayType | null

  // the setting is decided elsewhere, and the text says where
  disabled?: boolean
  disabledText?: ReactNode
}

const ComparativeDisplayTypeSection = (
  props: ComparativeDisplayTypeSectionProps
) => {
  const {
    disabled, disabledText, hasComparativePeriod, onChange, options, selected
  } = props
  const { t, translateEnum } = useTranslation()

  if (!hasComparativePeriod || options.length <= 1) return null

  const handleToggle = (option: ComparativeDisplayType) => {
    onChange(
      selected === option ? ComparativeDisplayType.HIDDEN : option
    )
  }

  return (
    <SettingsGroup title={t('widgets', 'change_title')}>
      <SettingsItem disabled={disabled} disabledText={disabledText}>
        <Grid container={true} columns={5}>
          {getOptions(options).map((option) => (
            <Grid item={true} key={option} xs={1}>
              <SettingsToggleOption
                disabled={disabled}
                iconName={translateComparativeDisplayType[option].iconName}
                onClick={() => handleToggle(option)}
                selected={option === selected}
                title={translateEnum('comparative_display_types', option).title}
                tooltip={
                  translateEnum('comparative_display_types', option).tooltip
                }
              />
            </Grid>
          ))}
        </Grid>
      </SettingsItem>
      {selected !== null && selected !== ComparativeDisplayType.HIDDEN ? (
        <SettingsItem
          actions={
            <Switch
              checked
              disabled={disabled}
              onChange={() => onChange(ComparativeDisplayType.HIDDEN)}
              size="small"
            />
          }
          disabled={disabled}
          disabledText={disabledText}
          title={t('global', 'activated')}
        />
      ) : null}
    </SettingsGroup>
  )
}

export default ComparativeDisplayTypeSection
